import { Copy, Edit2, Trash2 } from 'lucide-react';

interface TaskContextMenuProps {
  x: number;
  y: number;
  onEdit?: () => void;
  onDelete?: () => void;
  onDuplicate?: () => void;
  onClose: () => void;
}

export function TaskContextMenu({ x, y, onEdit, onDelete, onDuplicate, onClose }: TaskContextMenuProps) {
  const adjustedY = Math.min(y, window.innerHeight - 160);
  const adjustedX = Math.min(x, window.innerWidth - 192);

  return (
    <>
      <div className="fixed inset-0 z-40" onClick={onClose} />
      <div
        className="fixed z-50 w-48 bg-white rounded-lg shadow-xl border border-grey-200 py-1"
        style={{ top: adjustedY, left: adjustedX }}
      >
        {onDuplicate && (
          <button
            onClick={(e) => { e.stopPropagation(); onDuplicate(); onClose(); }}
            className="w-full flex items-center gap-2 px-3 py-2 text-sm text-secondary hover:bg-grey-50 transition-colors"
          >
            <Copy className="w-4 h-4" />
            Duplicate Task
          </button>
        )}
        {onEdit && (
          <button
            onClick={(e) => { e.stopPropagation(); onEdit(); onClose(); }}
            className="w-full flex items-center gap-2 px-3 py-2 text-sm text-secondary hover:bg-grey-50 transition-colors"
          >
            <Edit2 className="w-4 h-4" />
            Edit
          </button>
        )}
        {onDelete && (
          <button
            onClick={(e) => { e.stopPropagation(); onDelete(); onClose(); }}
            className="w-full flex items-center gap-2 px-3 py-2 text-sm text-error hover:bg-error/5 transition-colors"
          >
            <Trash2 className="w-4 h-4" />
            Delete
          </button>
        )}
      </div>
    </>
  );
}
